@import "styles/variables";

.toggle-button {
	display: inline-block;
}

.toggle-button-input {
	position: absolute;
	left: -9999px;	
}

.toggle-button-input:focus ~ .toggle-button-label {
  border-color: var(--color-yellow);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);	
}

.toggle-button-label {
	position: relative;
	width: 44px;
	height: 22px;
	border-radius: 12px;
	border: 1px solid var(--color-grey);
	background-color: var(--color-grey);
	cursor: pointer;
	transition: background-color 0.1s ease-out;
}

.toggle-button-label:after {
	position: absolute;
	content: '';
	display: block;
	background-color: var(--color-white);
  height: 22px;
  width: 22px;
  border-radius: 50%;
  transition: transform 0.1s ease-out;
}

.toggle-button-input:checked + .toggle-button-label {
	background-color: var(--color-yellow);
	border-color: var(--color-yellow);
}

.toggle-button-input:checked + .toggle-button-label:after {
	transform: translateX(100%);
}